import { render, staticRenderFns } from "./Spinner2.vue?vue&type=template&id=1218983d&scoped=true"
import script from "./Spinner2.vue?vue&type=script&lang=js"
export * from "./Spinner2.vue?vue&type=script&lang=js"
import style0 from "./Spinner2.vue?vue&type=style&index=0&id=1218983d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1218983d",
  null
  
)

export default component.exports